module.exports = __webpack_public_path__ + "media/berlin/employers-map-berlin-72164305.webp";